import React, { useEffect, useState } from "react";
import { getSportsCommunityBadge } from "store/actions/SportCommunityBadgeAction";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Header from "../../components/Headers/Header";
import {
  Card,
  Container,
  Spinner,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { sendNotification } from "store/actions/SportCommunityBadgeAction";

const SportsCommunityBadge = () => {
  const dispatch = useDispatch();
  const { sportsCommunityBadge } = useSelector(
    (state) => state.sportsCommunityBadge
  );
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");
  const [notificationText, setNotificationText] = useState("");

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const handleSendNotification = () => {
    if (!selectedRole || !notificationText) {
      toast.error("Please select a role and write a notification.");
      return;
    }
    setSending(true);
    dispatch(
      sendNotification(
        selectedRole, 
        notificationText, 
        () => {
          setSelectedRole("");
          setNotificationText("");
          setModalOpen(false);
          setSending(false);
        }
      )
    );
  };

  useEffect(() => {
    setLoading(true);
    dispatch(
      getSportsCommunityBadge(() => {
        setLoading(false);
      })
    );
  }, [dispatch]);

  const roles = [
    ...new Set(sportsCommunityBadge.map((athlete) => athlete?.userData?.role)),
  ];

  return (
    <>
      <Header />
      <Container fluid className="mb-5">
        <div className="d-flex justify-content-between align-items-center">
          <h2>Community Members</h2>
          <Button color="primary" onClick={toggleModal}>
            Send Notification
          </Button>
        </div>

        <Card className="p-2 mt-3">
          {loading ? (
            <div className="text-center my-4">
              <Spinner size="lg" color="primary" />
            </div>
          ) : (
            <>
              <Table className="align-items-center table-flush mt-3" responsive>
                <thead>
                  <tr>
                    <th className="custom-table-heading custom-heading ">
                      Email
                    </th>
                    <th className="custom-table-heading custom-heading ">
                      Phone No
                    </th>
                    <th className="custom-table-heading custom-heading ">
                      Address
                    </th>
                    <th className="custom-table-heading custom-heading ">
                      Registered As
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sportsCommunityBadge.map((athlete, idx) => (
                    <tr key={athlete.id}>
                      <td
                        scope="row"
                        className="custom-table-text truncated-text"
                      >
                        {athlete?.userData?.email}
                      </td>
                      <td className="custom-table-text truncated-text">
                        {athlete?.userData?.phoneNumber ||
                          athlete?.userData?.phone ||
                          "N/A"}
                      </td>
                      <td className="custom-table-text truncated-text">
                        {athlete?.userData?.state +
                          " " +
                          (athlete?.userData?.city ||
                            athlete?.userData?.county ||
                            "")}
                      </td>
                      <td className="custom-table-text truncated-text">
                        {athlete?.userData?.role}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </Card>
      </Container>

      {/* Modal */}
      <Modal isOpen={modalOpen} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal}>Send Notification</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="roleSelect">Select Role</Label>
              <Input
                type="select"
                id="roleSelect"
                value={selectedRole}
                onChange={(e) => setSelectedRole(e.target.value)}
              >
                <option value="">-- Select --</option>
                <option value="all">All</option>
                {roles.map((role, idx) => (
                  <option key={idx} value={role}>
                    {role}
                  </option>
                ))}
              </Input>
            </FormGroup>

            <FormGroup>
              <Label for="notificationText">Notification</Label>
              <Input
                type="textarea"
                id="notificationText"
                placeholder="Write your notification..."
                value={notificationText}
                onChange={(e) => setNotificationText(e.target.value)}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal} disabled={sending}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleSendNotification} disabled={sending}>
            {sending ? "Sending..." : "Send"}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default SportsCommunityBadge;
